module.exports = __webpack_public_path__ + "static/media/Icona-11.9229d14c.svg";